export const environment = {
  production: false,
  API_ENDPOINT: 'https://staging.apigenie.app/api/v1/'
};
